import React, { useEffect } from "react";
import FileUpload from "../../components/Esign/Fileupload";
import PdfMiniView from "../../components/Esign/pdfMiniView";
import { useSelector, useDispatch } from "react-redux";
import { setUploadedDocument } from "../../store/reducers/uploadDocumentSlice";
import { useNavigate } from "react-router-dom";

const PdfEditor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { uploadedDocument } = useSelector((state) => state.uploadDocument);

  useEffect(() => {
    const savedDoc = localStorage.getItem("uploadedDocument");
    if (!uploadedDocument && savedDoc) {
      dispatch(setUploadedDocument(JSON.parse(savedDoc)));
    }
  }, [uploadedDocument, dispatch]);

  // ✅ Move navigate logic into useEffect
  useEffect(() => {
    if (uploadedDocument?.data?.document_id || uploadedDocument?.fullView) {
      navigate("/esign/pdfeditor", { replace: true });
    }
  }, [uploadedDocument, navigate]);

  return <FileUpload />;
};

export default PdfEditor;
